(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningCategoryDeleteController',WarningCategoryDeleteController);

    WarningCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'WarningCategory'];

    function WarningCategoryDeleteController($uibModalInstance, entity, WarningCategory) {
        var vm = this;
        vm.warningCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            WarningCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
